import { render, staticRenderFns } from "./MiroOnboardingSteps.vue?vue&type=template&id=0b82fd4d"
import script from "./MiroOnboardingSteps.vue?vue&type=script&lang=ts"
export * from "./MiroOnboardingSteps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports